module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation-mobile"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.active),
      expression: "!active"
    }],
    staticClass: "navigation-mobile__container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "navigation-mobile__logo"
  }, [_c('Icon', {
    attrs: {
      "name": "logo"
    }
  })], 1)]), _c('div', {
    staticClass: "navigation-mobile__hamburger",
    on: {
      "click": function($event) {
        _vm.active = true
      }
    }
  }, [_vm._v("Menu")])], 1), _c('div', {
    staticClass: "navigation-mobile__links-container",
    class: {
      'navigation-mobile__links-container--active': _vm.active
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "navigation-mobile__container",
    class: {
      "navigation-mobile__container--active": _vm.active
    }
  }, [_c('div', {
    staticClass: "navigation-mobile__links",
    on: {
      "click": function($event) {
        _vm.active = false
      }
    }
  }, [_c('div', {
    staticClass: "navigation-mobile__link"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "navigation-mobile__logo"
  }, [_c('Icon', {
    attrs: {
      "name": "logo"
    }
  })], 1)])], 1), _vm._l((_vm.props), function(nav) {
    return (nav.navigation) ? _c('div', {
      staticClass: "navigation-mobile__link"
    }, [_c('router-link', {
      attrs: {
        "to": nav.path
      }
    }, [_c('a', [_vm._v(_vm._s(nav.name))])])], 1) : _vm._e()
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d740b60","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation-mobile/navigation-mobile.pug
// module id = 604
// module chunks = 1